import { render, staticRenderFns } from "./ClientRoutePage.vue?vue&type=template&id=8b079b9c&"
import script from "./ClientRoutePage.vue?vue&type=script&lang=js&"
export * from "./ClientRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports